import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../../common/footer/footer.component';
import { HeaderComponent } from '../../../common/header/header.component';

@Component({
  selector: 'app-website-layouts',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './website-layouts.component.html',
  styleUrl: './website-layouts.component.scss',
})
export class WebsiteLayoutsComponent {}
